export interface IDetailTab {
  link: string;
  label: string;
  disabled?: boolean;
  policyKey?: string;
  hasReassignPolicy?: boolean;
}
